import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { WatcherService } from "src/app/services/watcher.service";

@Component({
    selector: "app-shop-shein-us",
    templateUrl: "./shop-shein-us.component.html",
    styleUrls: ["./shop-shein-us.component.css"],
})

export class ShopSheinUsComponent implements OnInit, OnDestroy {

    lang: string = 'en';
    constructor(
        private watcherService: WatcherService,
        private router: Router
    ) {

    }

    createSheinSchema() {
        if (window.document.getElementById('shopSheinUsSchema')) {
            return;
        } else {
            const sheinSchema = {
                "@context": "https://schema.org ",
                "@type": "Article",
                "headline": "How to Shop Shein US and Ship Internationally",
                "image": [
                  "https://www.shippn.com/assets/img/stores/shein/How_to_Ship_Shein_Clothing_Internationally.avif",
                  "https://www.shippn.com/assets/img/stores/shein/Shippn_Get_Address.webp", 
                  "https://www.shippn.com/assets/img/stores/shein/Shein_Account_step.webp", 
                  "https://www.shippn.com/assets/img/stores/shein/Shein_add_address.webp", 
                  "https://www.shippn.com/assets/img/stores/shein/Adding_Hosts_Address.webp"
                 ],
                "datePublished": "2025-03-14T12:37:01.294544Z",
                "dateModified": "2025-03-14T12:37:01.294544Z",
                "author": [{
                    "@type": "Person",
                    "name": "Shippn Team",
                    "url": `https://www.shippn.com/${this.lang}/about`
                }]
              }
            const scriptEl = window.document.createElement('script');
            scriptEl.type = 'application/ld+json';
            scriptEl.innerHTML = JSON.stringify(sheinSchema);
            scriptEl.id = 'shopSheinUsSchema';
            window.document.head.appendChild(scriptEl);
        }
    }

    ngOnInit(): void {
        this.watcherService.getLang().subscribe(lang => {
            this.lang = lang;
            this.createSheinSchema()
        })
        

    }

    goToSignIn() {
        this.router.navigate(['/', this.lang, 'signin']);
    }

    ngOnDestroy(): void {
        const sheinSchemaScript = window.document.getElementById('shopSheinUsSchema');

        if (sheinSchemaScript) {
            window.document.head.removeChild(sheinSchemaScript);
        }
    }
}